import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { durableKvStorage } from "@/lib/browser/durableKvStorage";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase: SupabaseClient | null =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          flowType: "pkce",
          detectSessionInUrl: true,
          persistSession: true,
          autoRefreshToken: true,
          storage: durableKvStorage,
        },
      })
    : null;

export function requireSupabase(): SupabaseClient {
  if (!supabaseUrl) throw new Error("VITE_SUPABASE_URL is not set.");
  if (!supabaseAnonKey) throw new Error("VITE_SUPABASE_ANON_KEY is not set.");
  if (!supabase) throw new Error("Supabase client is not initialized.");
  return supabase;
}

